export enum PedigreeSettingsFormatManagementFieldDelimiters {
    space = "space",
    comma = "comma",
    semiColon = "semiColon",
  }